export * from './components';
export { setupConfig } from '@ionic/core';